//REACT-JS
import React from 'react';
import { withRouter } from 'react-router-dom';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { relatorioAction } from '../../store/relatorio';

class TableDetalhadoSimplificado extends React.Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        selected: 0,
        onChange: function(e){}
    };

    render() {

        const data = this.props.data; let html = "";

        if (data.results === undefined) {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0 || data.results === 0) {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.identificador} id={row.codigo}>
                    <td>{row.identificador}</td>
                    <td>{row.remetenteEmail}</td>
                    <td>{row.assunto}</td>
                    <td>{row.dataHoraEnvio}</td>
                    <td>{row.email}</td>
                    <td>{row.dataHoraAbertura}</td>
                    <td>{row.dataHoraEntrega}</td>
                    <td>{row.dataHoraAberturaDocumento}</td>
                    <td>{row.documento}</td>
                    <td>{row.motivoNaoRecebimento}</td>
                </tr>                  
            );
        }

        return(
            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                <table className="footable table table-striped toggle-arrow-tiny text-body" id="table-to-export">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>       
                            <th>Identificador</th>
                            <th>Remetente</th>
                            <th>Assunto</th>
                            <th>Data envio</th>
                            <th>Destinatário</th>
                            <th>Data Leitura</th>
                            <th>Data Entrega</th>
                            <th>Data Abertura Anexo</th>
                            <th>Nome Anexo</th>
                            <th>Erro</th>
                        </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>            
            </div>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableDetalhadoSimplificado));